import axios from 'axios';
import request from '../setup/request';

// export const getWeather = (params) => {
//   console.log('api-----params---', params);
//   return axios.request({
//     url: 'http://yun-dev202.smallpay.com/da-dcapi/extra/common/weather',
//     params: params,
//     method: 'get',
//   });
// };

export const getWeather = (params) => {
  // console.log('api-----params---', params);
  return request.post('', {
    ...params,
    method: 'ih.public.weather.info',
  });
};
